import { render, staticRenderFns } from "./EditLiveReviewTrackerCoverageLegend.vue?vue&type=template&id=1ebae2bb"
import script from "./EditLiveReviewTrackerCoverageLegend.vue?vue&type=script&lang=js"
export * from "./EditLiveReviewTrackerCoverageLegend.vue?vue&type=script&lang=js"
import style0 from "./EditLiveReviewTrackerCoverageLegend.vue?vue&type=style&index=0&id=1ebae2bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports